import { isOwnApprovalBySource } from '@/utils/util';
import { doNextRequest } from '@/api/index';

export default {
  computed: {
    ownApprovalFlag() {
      return isOwnApprovalBySource(this.$route.query.source);
    }
  },
  methods: {
    handleDoNext(data, successText, done) {
      if (this.ownApprovalFlag) {
        data['uuid'] = this.$route.query.uuid;
        data['platform'] = this.$route.query.platform;
        doNextRequest(data)
          .then((res) => {
            if (res.data.success && res.data.code === 200) {
              this.toast = this.$toast.success(successText);
              // 2s后关闭当前审批页面
              setTimeout(() => {
                iqh.closeWindow();
              }, 2000);
            }
          })
          .catch((error) => {
            alert(error);
          })
          .finally(() => {
            done();
          });
      } else {
        this.toast = this.$toast.success(successText);
        iqh.approveOrder(data);
        done();
      }
    }
  }
};
